/**全局变量*/
const path = process.env.VUE_APP_BASE_API;
const BASE_API = process.env.BASE_API;
//上传URL
const uploadURL = 'http://cdn.deephealth.net:9333/submit'

let exportURL = ''
if(BASE_API == 'https://admin.deephealth.net') {
  exportURL = 'https://admin.deephealth.net'
} else {
  exportURL = 'https://devpatient.deephealth.net/admin' // 测试
}
//导出URL
//生产环境api  101.200.205.159
// const exportURL = path

// const exportURL = 'https://admin.deephealth.net' // 正式
//接口本地调试api
//const exportURL = 'http://localhost:8083'
// const exportURL = 'https://devhealthadminapi.deephealth.net'
//统计页面是否显示治疗订单 1.显示 0.不显示
const treatmentFlag = 1
export default {
  uploadURL,
  exportURL,
  treatmentFlag
}



// WEBPACK FOOTER //
// ./src/api/global/globalVariable.js